{
    "events": {
        "pageViewHome": "Page_view_home",
        "pageViewAssessmentTest": "Page_view_assessment_test",
        "pageViewAssessmentResult": "Page_view_assessment_result",
        "pageViewAssessmentCompiling": "Page_view_assessment_compiling",
        "pageViewPreRoom": "Page_view_pre_room",
        "pageViewQuiz": "Page_view_quiz",
        "pageViewQuestion": "Page_view_question",
        "pageViewPowerScreen": "Page_view_power_screen",
        "pageViewEla": "Page_view_ELA",
        "pageViewProfile": "Page_view_profile",
        "pageViewLanding": "Page_view_landing",
        "clickGetOtp": "Click_get_otp",
        "popupView": "Popup_view",
        "popupViewOtp": "Popup_view_otp",
        "sendOtpFailed": "Send_otp_failed",
        "sendOtpSuccess": "Send_otp_success",
        "clickOtpResend": "Click_otp_resend",
        "sendPhoneNumberSuccess": "Send_phone_number_success",
        "sendBookingSuccess": "Send_booking_success",
        "sendBookingSuccessEla": "Send_booking_success_ela",
        "bookingRecordingRequestSuccess": "Booking_recording_request_success",
        "bookingRecordingRequestError": "Booking_recording_request_error",
        "popupViewCSBuild": "Popup_view_CS_build",
        "popupViewSwitchDevice": "Popup_view_switch_device",
        "popupViewIssueTicket": "Popup_view_issue_ticket",
        "popupIssueTicketSuccess": "Popup_issue_ticket_success",
        "popupIssueTicketError": "Popup_issue_ticket_error",
        "clickIssueTicketSubmit": "Click_issue_ticket_submit",
        "clickTaskCompleteSubmit": "Click_task_complete_submit",
        "popupViewDownsell": "Popup_view_downsell",
        "quizAnswers": "Quiz_answers",
        "zipIncomeFound": "Zip_income_found",
        "pageViewPAD": "Page_view_PAD",
        "clickEnrollNow": "Click_enroll_now",
        "clickTrustpilotReviews": "Click_trustpilot_reviews",
        "viewTrustpilotScreen": "View_trustpilot_screen",
        "selectLessonPackage": "Select_lesson_package",
        "selectFilePack": "Select_file_pack",
        "requestCallBack": "Request_call_back",
        "pageViewSelling": "Page_view_selling",
        "pageViewSellingDownsell": "Page_view_selling_downsell",
        "clickOfferButton": "Click_offer_button",
        "formView": "Form_view",
        "solidFormView": "Solid_form_view",
        "solidFormError": "Solid_form_error",
        "paypalButtonView": "Paypal_button_view",
        "paypalButtonClick": "Paypal_button_click",
        "paymentAttempt": "Payment_attempt",
        "paymentSuccessful": "Payment_successful",
        "paymentFailed": "Payment_failed",
        "paymentSubmit": "Payment_submit",
        "cardNumberFilled": "Card_number_filled",
        "demoPaymentSuccessful": "Demo_payment_successful",
        "pageViewDashboard": "Page_view_dashboard",
        "buttonViewJoinLesson": "Button_view_join_lesson",
        "additionalFeaturesView": "Additional_features_view",
        "clickJoinLesson": "Click_join_lesson",
        "clickLeave": "Click_leave",
        "clickSetUpDevice": "Click_set_up_device",
        "showBrowserNotification": "Show_browser_notification",
        "errorBrowserNotification": "Error_browser_notification",
        "clickBrowserNotification": "Click_browser_notification",
        "closeBrowserNotification": "Close_browser_notification",
        "pageViewSkillReport": "Page_view_skill_report",
        "popupViewAlreadyExist": "Popup_view_already_exist",
        "clickProductTourOpened": "Click_product_tour_opened",
        "clickProductTourClosed": "Click_product_tour_closed",
        "clickProductTourFinished": "Click_product_tour_finished",
        "clickProductTourNextTime":  "Click_product_tour_next_time",
        "clickProductTourNext":  "Click_product_tour_next",
        "clickProductTourBack":  "Click_product_tour_back",
        "clickFAQPAD": "Click_FAQ_PAD",
        "clickFAQQuestion": "Click_FAQ_question",
        "clickBNPLButton": "Click_BNPL_button",
        "clickReschedule": "Click_reschedule",
        "clickSchedule": "Click_schedule",
        "clickScheduleDay": "Click_schedule_day",
        "changeSchedule": "Change_schedule",
        "changeScheduleTime": "Change_schedule_time",
        "clickContactChannel": "Click_contact_channel",
        "clickReminderChannel": "Click_reminder_channel",
        "clickRemoveScheduleDay": "Click_remove_schedule_day",
        "clickCalendarDate": "Click_calendar_date",
        "clickContactMe": "Click_contact_me",
        "clickActivationButton": "Click_activation_button",
        "modalViewActivation": "Modal_view_activation",
        "modalViewActivationUnsaved": "Modal_view_activation_unsaved",
        "placeholderViewActivation": "Placeholder_view_activation",
        "placeholderViewJourney": "Placeholder_view_journey",
        "activationRequestSuccess": "Activation_request_success",
        "activationRequestError": "Activation_request_error",
        "modalScreenView": "Modal_screen_view",
        "scheduleSuccess": "Schedule_success",
        "sentAnswerQuestion": "Sent_answer_question",
        "pageViewLesson": "Page_view_lesson",
        "userConnected": "User_connected",
        "userDisconnected": "User_disconnected",
        "userLeaveRoom": "User_leave_room",
        "peerJoinedRoom": "Peer_joined_room",
        "peerLeftRoom": "Peer_left_room",
        "permissionsPopUp": "Permissions_pop_up",
        "popupViewPermissions": "Popup_view_permissions",
        "pipMode": "PIP_mode",
        "clickMic": "Click_mic",
        "clickCam": "Click_cam",
        "clickShare": "Click_share",
        "clickShareLessonLink": "Click_share_lesson_link",
        "clickButtonControls": "Click_button_controls",
        "clickButtonTutorMenu": "Click_button_tutor_menu",
        "clickAccountTab": "Click_account_tab",
        "clickRequestRefundSubmit": "Click_request_refund_submit",
        "clickStopShare": "Click_stop_share",
        "nearpodShare": "Nearpod_share",
        "clickChat": "Click_chat",
        "clickGuide": "Click_guides_100ms",
        "clickOpenGuide": "Click_open_guides_100ms",
        "clickGuideCategory": "Click_guides_category_100ms",
        "clickGuideBack": "Click_back_guides_100ms",
        "clickGuideClose": "Click_close_guides_100ms",
        "clickClosePopupPermissions": "Click_close_popup_permissions",
        "clickPIP": "Click_PIP",
        "clickScreenRecording": "Click_screen_recording",
        "screenRecording": "Screen_recording",
        "clickStillIssues": "Click_still_issues",
        "clickSettings": "Click_settings",
        "clickPADPayOption": "Click_PAD_payoption",
        "clickPackagesPayOption": "Click_Packages_payoption",
        "pageViewRebook": "Page_view_rebook",
        "clickRebook": "Click_rebook",
        "selectMicro": "Select_micro",
        "selectCamera": "Select_camera",
        "selectSpeaker": "Select_speaker",
        "sendRescheduleSubmit": "Send_reschedule_submit",
        "clickCallMeBack": "Click_call_me_back",
        "viewExitPopup": "View_exit_popup",
        "clickExitPopupClose": "Click_exit_popup_close",
        "exitPopupView": "Exit_popup_view",
        "clickExitPopupSend": "Click_exit_popup_send",
        "clickNotificationButton": "Click_notification_button",
        "clickWaitingRoomSubmit": "Click_waiting_room_submit",
        "popupViewWaitingRoom": "Popup_view_waiting_room",
        "popupViewAssessmentAnswers": "Popup_view_assessment_answers",
        "waitingRoomSuccess": "Waiting_room_success",
        "waitingRoomError": "Waiting_room_error",
        "waitingRoomKnockStart": "Waiting_room_knock_start",
        "waitingRoomKnockFinish": "Waiting_room_knock_finish",
        "christmasPopupView": "Сhristmas_popup_view",
        "clickBanner": "Click_banner",
        "clickSummerDiscountBanner": "Click_summer_discount_banner",
        "clickChristmasModalSkip": "Click_christmas_modal_skip",
        "pageViewFiles": "Page_view_files",
        "pageViewAllLessons": "Page_view_all_lessons",
        "pageViewPackages": "Page_view_packages",
        "pageViewOrders": "Page_view_orders",
        "pageViewHelpCenter": "Page_view_helpcenter",
        "pageViewReferral": "Page_view_referral",
        "pageViewMyAccount": "Page_view_my_account",
        "clickEnroll": "Click_enroll",
        "clickViewFile": "Click_view_file",
        "clickDeleteDraftFile": "Click_delete_draft_file",
        "clickDownloadFile": "Click_download_file",
        "clickFilePack": "Click_file_pack",
        "clickSendFilesButton": "Click_send_files_button",
        "clickSendFilesSubmit": "Click_send_files_submit",
        "sendFilesSuccess": "Send_files_success",
        "clickFilesCancelButton": "Click_files_cancel_button",
        "popupUnsavedChangesView": "Popup_unsaved_changes_view",
        "clickKeepEditingButton": "Click_keep_editing_button",
        "clickDiscardButton": "Click_discard_button",
        "clickHelpcenterSubmit": "Click_helpcenter_submit",
        "selectFilesCategory": "Select_files_category",
        "enterFilesComment": "Enter_files_comment",
        "uploadFiles": "Upload_files",
        "clickAllLessons": "Click_all_lessons",
        "modalViewReferralInfo": "Modal_view_referral_info",
        "modalViewReferralSuccess": "Modal_view_referral_success",
        "clickUseItNowButton": "Click_use_it_now_button",
        "clickInviteFriendsButton": "Click_invite_friends_button",
        "inviteReferralAction": "Invite_referral_action",
        "toggleDropdownMenu": "Toggle_dropdown_menu",
        "clickDropdownLink": "Click_dropdown_link",
        "clickDropdownButton": "Click_dropdown_button",
        "clickButton": "Click_button",
        "clickLink": "Click_link",
        "clickAnchorButton": "Click_anchor_button",
        "clickAnswerButton": "Click_answer_button",
        "clickEditButton": "Click_edit_button",
        "clickButtonNextChild": "Click_button_next_child",
        "clickCloseButton": "Click_close_button",
        "clickMenuButton": "Click_menu_button",
        "clickActionButton": "Click_action_button",
        "clickZoomLink": "Click_ZOOM_link",
        "payMethodView": "Pay_method_view",
        "clickPaymentMethodKebab": "Click_payment_method_kebab",
        "clickTab": "Click_tab",
        "clickPayMethodButton": "Click_pay_method_button",
        "clickChangePayMethodSubmit": "Click_change_pay_method_submit",
        "clickChangePayMethodCancel": "Click_change_pay_method_cancel",
        "changePayMethodSuccess": "Change_pay_method_success",
        "clickDeletePayMethodSubmit": "Click_delete_pay_method_submit",
        "clickDeletePayMethodCancel": "Click_delete_pay_method_cancel",
        "clickAddCard": "Click_add_card",
        "deletePayMethodSuccess": "Delete_pay_method_success",
        "pageViewLogin": "Page_view_login",
        "clickSendAccessCode": "Click_send_access_code",
        "clickResendCode": "Click_resend_code",
        "loginSuccessfully": "Login_successfully",
        "productTourView":  "Product_tour_view",
        "clickCard": "Сlick_card",
        "clickCancel": "Сlick_cancel",
        "clickCheckbox": "Click_checkbox",
        "clickRadio": "Click_radio",
        "lessonCanceled": "Lesson_canceled",
        "clickWABanner": "Click_WA_banner",
        "sendRefundRequest": "Send_refund_request",
        "sendCancelRequest": "Send_cancel_request",
        "clickSummerDiscountPromocode": "Click_summer_discount_promocode",
        "clickCloseSWPromocodeBanner": "Click_close_Star_Wars_promocode_banner",
        "pageViewCheckout": "Page_view_checkout",
        "pageViewProgressReports": "Page_view_progress_reports",
        "pageViewProgressReport": "Page_view_progress_report",
        "checkoutCreated": "Checkout_created",
        "popupViewMessengerSubscription": "Popup_view_messenger_subscription",
        "clickMessengerButton": "Click_messenger_button",
        "popupClickMessengerSubscription": "Popup_click_messenger_subscription",
        "pageViewPrePayment": "Page_view_pre_payment",
        "pageViewEnroll": "Page_view_enroll",
        "hmsErrorNotification": "HMS_error_notification",
        "surveyView": "Survey_view",
        "oAuthSuccess": "OAuth_success",
        "oAuthError": "OAuth_error",
        "clickButtonOAuth": "Click_button_OAuth",
        "clickButtonRemovePeer": "Click_button_remove_peer",
        "removePeerSuccess": "Remove_peer_success",
        "removePeerError": "Remove_peer_error",
        "popupViewWaitingLesson": "Popup_view_waiting_lesson",
        "checkRedirectToLesson": "Check_redirect_to_lesson",
        "startRedirectToLesson": "Start_redirect_to_lesson",
        "customerLessonUpdate": "Customer_lesson_update",
        "clickClosePopupBNPL": "Click_close_popup_BNPL",
        "popupViewBNPL": "Popup_view_BNPL",
        "clickCSConfirm": "Click_CS_confirm",
        "clickCSConfirmClose": "Click_CS_confirm_close",
        "clickLongBooking": "Click_long_booking",
        "selectLessonsPace": "Select_lessons_pace",
        "selectLearningPeriod": "Select_learning_period",
        "selectTutorCategory": "Select_tutor_category",
        "selectPaymentMethod": "Select_payment_method",
        "clickSeeSubscriptionDetails": "Click_see_subscription_details",
        "clickSeeRefundPolicy": "Click_see_refund_policy",
        "clickBackButton": "Click_back_button",
        "clickPadFaqClose": "Click_pad_faq_close",
        "popupViewSuccessConfirmation": "Popup_view_success_confirmation",
        "clickSuccessConfirmationPopup": "Click_success_confirmation_popup",
        "clickCheckOurPlans": "Click_check_our_plans",
        "editTextarea": "Edit_textarea",
        "selectIssueCategories": "Select_issue_categories",
        "popupViewGetLessons": "Popup_view_get_lessons",
        "clickClosePopupGetLessons": "Click_close_popup_get_lessons",
        "clickClosePopupTutorReservation": "Click_close_popup_tutor_reservation",
        "popupViewSurveyFinish": "Popup_view_survey_finish",
        "popupViewTutorReservation": "Popup_view_tutor_reservation",
        "popupViewTaskDetails": "Popup_view_task_details",
        "popupViewTaskComplete": "Popup_view_task_complete",
        "popupViewTaskPostpone": "Popup_view_task_postpone",
        "popupViewRequestRefund": "Popup_view_request_refund",
        "taskCancelSuccess": "Task_cancel_success",
        "taskCompleteSuccess": "Task_complete_success",
        "taskCancelError": "Task_cancel_error",
        "taskCompleteError": "Task_complete_error",
        "taskPostponeSuccess": "Task_postpone_success",
        "taskPostponeError": "Task_postpone_error",
        "popupViewRequests": "Popup_view_requests",
        "modalViewSendFiles": "Modal_view_send_files",
        "modalViewGenerateCertificate": "Modal_view_generate_certificate",
        "modalViewEditFiles": "Modal_view_edit_files",
        "modalViewConfirmation": "Modal_view_confirmation",
        "clickRequestSubmit": "Click_request_submit",
        "popupRequestSuccess": "Popup_request_success",
        "popupRequestError": "Popup_request_error",
        "sectionView": "Section_view",
        "offerBannerView": "Offer_banner_view",
        "offerBannerClick": "Offer_banner_click",
        "pageViewSchedule": "Page_view_schedule",
        "pageViewPayments": "Page_view_payments",
        "pageViewWeeklySchedule": "Page_view_weekly_schedule",
        "clickSubmitButton": "Click_submit_button",
        "requestSuccess": "Request_success",
        "requestError": "Request_error",
        "pageViewTutorProfile": "Page_view_tutor_profile",
        "pageViewTutorTasks": "Page_view_tutor_tasks",
        "pageViewChildrenProfile": "Page_view_tutor_tasks",
        "modalViewUpdatePolicy": "Modal_view_update_policy",
        "applyPromocodeRequestSuccess": "Apply_promocode_request_success",
        "applyPromocodeRequestError": "Apply_promocode_request_error",
        "applyCreditsRequestSuccess": "Apply_credits_request_success",
        "reminderRequestSuccess": "Notification_request_success",
        "applyCreditsRequestError": "Apply_credits_request_error",
        "reminderRequestError": "Notification_request_error",
        "clickCloseAssessmentBanner": "Click_close_assessment_banner",
        "viewAssessmentBanner": "View_assessment_banner",
        "pageViewStudentsProfile": "Page_view_students_profile",
        "enterStudentNotes": "Select_student_notes",
        "clickSubmitStudentNotes": "Click_submit_student_notes",
        "requestStudentNotesSuccess": "Request_student_notes_success",
        "requestStudentNotesError": "Request_student_notes_error",
        "clickSubmitStudentLesson": "Click_submit_student_lesson",
        "requestStudentLessonSuccess": "Request_student_lesson_success",
        "requestStudentLessonError": "Request_student_lesson_error",
        "modalViewReminder": "Modal_view_reminder",
        "clickPremiumBanner": "Click_premium_banner",
        "viewPremiumModal": "View_premium_modal",
        "modalClickAdd": "Modal_click_add",
        "bannerView": "Banner_view",
        "waitingListSuccess": "waiting_list_success",
        "richLead": "Rich_lead",
        "clickSelect": "Click_select",
        "pageViewTutorUpsell": "Page_view_tutor_upsell",
        "sendRequest": "Send_request",
        "inputFocus": "Input_focus",
        "inputChange": "Input_change",
        "inputBlur": "Input_blur",
        "selectChange": "Select_change",
        "selectFocus": "Select_focus",
        "selectBlur": "Select_blur",
        "tooltipView": "Tooltip_view",
        "clickSkipQuestion": "Click_skip_question",
        "clickSubmitQuestion": "Click_submit_question",
        "activationView": "Activation_view",
        "modalView": "Modal_view",
        "pageNotFound": "Page_not_found",
        "aggregatorCardApply": "Aggregator_card_apply",
        "aggregatorCardView": "Aggregator_card_view"
    }
}
